import React from "react";
import { useNavigate } from "react-router-dom";
import { GoogleAnalytics } from "../../types/GoogleAnalytics";

export const PriceIsAGuide = ({
  analytics
}: {
  analytics: GoogleAnalytics;
}) => {
  const navigate = useNavigate();
  return (
    <div className={`ch-mt--4 ch-display--flex ch-justify-content--center`}>
      <div className="ch-text--left ch-width--12 sl:ch-width--7 sm:ch-width--5 md:ch-width--4 lg:ch-width--3 ch-text--center">
        <p>
          *This <b>price is a guide</b> based on{" "}
          <a
            className="ch-pt--0 ch-btn--link ch-hand"
            onClick={() => navigate("/assumptions")}
            {...analytics}
          >
            these assumptions
          </a>{" "}
          and is subject to a branch appraisal.
        </p>
      </div>
    </div>
  );
};
